import { _ } from "../../../core/polyglot/polyglot.js";
import TextRepresentationDimensionSpecificationVisitor from "./TextRepresentationDimensionSpecificationVisitor.js";

/**
 * A dimension specification visitor this returns a text representation of the visited specification.
 * If the specification consists of a sole dimension, returns the label of this dimension.
 * Otherwise returns 'n dimensions' where n is the number of dimensions in the specificaiton.
 */
export default class ShortTextRepresentationDimensionSpecificationVisitor extends TextRepresentationDimensionSpecificationVisitor {
	visitAndSpecification(aSpecification) {
		const count = aSpecification.leaves().length;
		if (count > 1) {
			return _("{count} dimensions", { count });
		}
		return super.visitAndSpecification(aSpecification);
	}

	visitOrSpecification(aSpecification) {
		const count = aSpecification.leaves().length;
		if (count > 1) {
			return _("{count} dimensions", { count });
		}
		return super.visitOrSpecification(aSpecification);
	}

	visitNotSpecification(aSpecification) {
		const negatedSpecification = aSpecification.getSpecification();
		const negatedSpecificationText = negatedSpecification.accept(this);
		if (negatedSpecification.isLeaf()) {
			return _("excluding {label}", { label: negatedSpecificationText });
		}

		return negatedSpecificationText;
	}
}
